import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Seo from "@/components/seo/Seo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
    return (
        <Layout withFooter={false}>
            <Seo title="404" path="/404" noIndex />
            <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center text-center px-4">
                <div>
                    <div className="font-mono text-xs uppercase tracking-[0.4em] text-primary mb-4">
                        ▌ ERROR 404
                    </div>
                    <h1 className="text-6xl md:text-8xl font-black uppercase tracking-tighter mb-4">
                        Off side
                    </h1>
                    <p className="text-zinc-400 mb-8 max-w-md mx-auto">
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                    <Link to="/">
                        <Button className="rounded-none bg-primary text-primary-foreground hover:bg-[#33FFB0] font-bold uppercase tracking-wider">
                            Back to home
                        </Button>
                    </Link>
                </div>
            </div>
        </Layout>
    );
}
